import React from "react";
import { Link } from "react-router-dom";
import { Check, Star } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { PRICING_PLANS, breadcrumbLd } from "@/lib/siteContent";
import { Button } from "@/components/ui/button";

const crumbs = [{ label: "Home", to: "/" }, { label: "Pricing", to: "/pricing" }];

export default function Pricing() {
  return (
    <div className="ca-container py-12">
      <Seo title="Vendor Subscription and Featured Listing Plans | ComplaintAdvisor"
        description="Explore ComplaintAdvisor vendor subscription and promotional listing plans. Compare profile features, enquiry tools, and advertising options with clear disclosures."
        path="/pricing" jsonld={breadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-3">Plans for Vendors and Businesses</h1>
      <p className="text-slate-600 mt-2 max-w-2xl">Choose a plan for your business profile and promotional visibility. Paid placement is clearly labelled and does not affect complaint moderation, reviews, or dispute outcomes.</p>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {PRICING_PLANS.map((p) => (
          <div key={p.name} data-testid={`plan-${p.name.toLowerCase()}`}
            className={`rounded-2xl border bg-white p-5 flex flex-col ${p.popular ? "border-teal-brand ring-2 ring-teal-brand/20" : "border-slate-200"}`}>
            {p.popular && <span className="inline-flex items-center gap-1 self-start rounded-full bg-teal-brand text-white px-2 py-0.5 text-[10px] font-bold uppercase mb-2"><Star className="h-3 w-3" /> Popular</span>}
            <h2 className="font-display text-lg font-bold text-slate-900">{p.name}</h2>
            <p className="mt-1"><span className="text-2xl font-extrabold text-slate-900">{p.price}</span> <span className="text-xs text-slate-500">/ {p.period}</span></p>
            <ul className="mt-4 space-y-2 flex-1">
              {p.features.map((f) => <li key={f} className="text-sm text-slate-600 flex gap-2"><Check className="h-4 w-4 text-teal shrink-0 mt-0.5" /> {f}</li>)}
            </ul>
            <Link to="/vendors/list-your-business" className="mt-4"><Button className={`w-full ${p.popular ? "bg-teal-brand hover:bg-teal-700 text-white" : ""}`} variant={p.popular ? "default" : "outline"} data-testid={`plan-cta-${p.name.toLowerCase()}`}>Get started</Button></Link>
          </div>
        ))}
      </div>

      <div className="mt-8 rounded-xl bg-slate-50 border border-slate-200 p-4 text-sm text-slate-600 max-w-3xl">
        Prices shown are indicative and configurable. We do not promise leads, sales, bookings, rankings, or conversions.
        Billing period, taxes, cancellation, refund, and renewal terms are shown at checkout. Payment must not affect complaint moderation, review decisions, or dispute outcomes.
      </div>
    </div>
  );
}
